const key = "TOAST"

export const TOAST = {
        CLEAR: `${key}_CLEAR`,
        SUCCESS: `${key}_SUCCESS`,
        ERROR: `${key}_ERROR`,
};